import { render } from "./AppUser.vue?vue&type=template&id=656c21a3&scoped=true"
const script = {}

import "./AppUser.vue?vue&type=style&index=0&id=656c21a3&lang=scss"
import "./AppUser.vue?vue&type=style&index=1&id=656c21a3&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656c21a3"]])

export default __exports__